<div class="modal-header">
  <div class="modal-header-content">
    <h1 class="modal-title">Add set</h1>
    <h2 class="modal-subtitle">Select the following options to create a new set of files.</h2>
  </div>
  <i class="ic-close icon-size-32" (click)="activeModal.close()"></i>
</div>
<div class="modal-body form-container">
  <ng-container *ngFor='let tabConfiguration of tabs?.tab_configuration'>
    <div class="config form-group">
      <div class="name-container">
        <label
          class="label"
          [class.text-error]="tabConfiguration.name !== 'Recovery Rate' && !tabConfiguration.choosen_value && submitted || tabConfiguration.name === 'Recovery Rate' && isRecoveryRateNotValid"
        >
        {{tabConfiguration.name}}
      </label>
      </div>
      <input
        type="text"
        class="form-control"
        *ngIf='tabConfiguration.name === "Recovery Rate"; else selectCustom'
        [(ngModel)]="tabConfiguration.choosen_value"
        placeholder='Insert value'
        (blur)="getRecoveryRateValue(tabConfiguration.choosen_value)"
      >
      <small
        class="text-error"
        *ngIf="tabConfiguration.name !== 'Recovery Rate' && !tabConfiguration.choosen_value && submitted">
        Choose an option
      </small>
      <small
        class="text-error"
        *ngIf="tabConfiguration.name === 'Recovery Rate' && isRecoveryRateNotValid">
        The value entered for the Recovery Rate does not a valid number
      </small>
      <ng-template #selectCustom>
          <ng-select
             class='custom select-custom-config select-check-value'
             [clearable]="false"
             [addTag]="addCurrency"
             bindLabel="value"
             bindValue="id"
             [(ngModel)]='tabConfiguration.choosen_value'
             [items]='tabConfiguration.values'
             placeholder='Select or create an option'
             [class.is-invalid]="!tabConfiguration.choosen_value && submitted">
          </ng-select>
      </ng-template>
    </div>
  </ng-container>
  <!-- <div class="form-group sections-type-wrapper">
    <label class="input-title name w-100">Scenario type</label>
    <div class="modal-type-btn d-inline-flex justify-content-around">
      <a
        class="section-type-btn btn-clear round-0"
        [ngClass]="{'active': i === 0 }"
        role="button"
        *ngFor="let section of tabs?.sections; let i = index"
        (click)='handleCollapse($event)'
      >
        {{section.type}}
      </a>
    </div>
  </div> -->
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">Cancel</button>
  <button
    class="btn btn-default ml-3"
    type='submit'
    (click)='onSave()'>
    Save
  </button>
</div>
